import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus";
export let iconMinus = faMinus;
export function overwriteMinus(icon) {
    iconMinus = icon;
}
export default iconMinus;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWludXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbWludXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLDJDQUEyQyxDQUFDO0FBRXBFLE1BQU0sQ0FBQyxJQUFJLFNBQVMsR0FBRyxPQUFPLENBQUM7QUFFL0IsTUFBTSxVQUFVLGNBQWMsQ0FBQyxJQUFvQjtJQUNqRCxTQUFTLEdBQUcsSUFBSSxDQUFDO0FBQ25CLENBQUM7QUFFRCxlQUFlLFNBQVMsQ0FBQyJ9